import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, CanActivate, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { HelperService } from 'src/app/services/shared/helper/helper.service';

@Injectable({
  providedIn: 'root'
})
export class LoggedOnGuard implements CanActivate {
  constructor(private _helper: HelperService, private _router: Router){}
  
  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    if(this._helper.token.get()){
      this._router.navigate(['/landing/customer-list']);
    }else{
      return true;
    }    
  }
}
